// extracted by mini-css-extract-plugin
module.exports = {"contentContainer":"HelpContainer_contentContainer__1WcjI","question":"HelpContainer_question__3tEn1","answer":"HelpContainer_answer__wBJZN"};